import { Query } from '../../hooks/queries'
import { useContrastQuery } from '../../hooks/use-contrast-query'
import { ProtectRule } from './shared'
import {
  ProtectRulesParams,
  ProtectRulesQueryArgs,
  getProtectRulesSummary
} from '../../api/queries/protect-rules'

export function useProtectRulesSummary(
  organizationUuid: string,
  protectRulesParams?: ProtectRulesParams
) {
  return useContrastQuery<ProtectRulesQueryArgs, ProtectRule[]>(
    [Query.PROTECT_RULES_SUMMARY, protectRulesParams],
    getProtectRulesSummary,
    {
      organizationUuid,
      ...protectRulesParams
    },
    { notifyOnChangeProps: 'tracked', cacheTime: 0 }
  )
}
